export const TEXTOS_FINANCEIRO_DETALHES = {
  pt: {
    Detalhes: "Detalhes",
    "Selecione um lançamento": "Selecione um lançamento",
    Recebidas: "Recebidas",
    "Data de recebimento": "Data de recebimento",
    "Data de pagamento": "Data de pagamento",
    "Valor pago": "Valor pago",
  },
  en: {
    Detalhes: "Details",
    "Selecione um lançamento": "Select an entry",
    Recebidas: "Received",
    "Data de recebimento": "Receipt date",
    "Data de pagamento": "Payment date",
    "Valor pago": "Amount paid",
  },
  es: {
    Detalhes: "Detalles",
    "Selecione um lançamento": "Seleccione un registro",
    Recebidas: "Recibidas",
    "Data de recebimento": "Fecha de recepción",
    "Data de pagamento": "Fecha de pago",
    "Valor pago": "Valor pagado",
  },
  "zh-CN": {
    Detalhes: "详情",
    "Selecione um lançamento": "选择一条记录",
    Recebidas: "已收到",
    "Data de recebimento": "收款日期",
    "Data de pagamento": "付款日期",
    "Valor pago": "已付金额",
  },
};
